<template>
    <b-modal ref="modal" title="Nuova Misurazione" size="lg" centered scrollable no-close-on-backdrop no-close-on-esc hide-header-close @hidden="onHidden">
        <b-form @submit.prevent="onSave">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Tipo parametro" label-for="parametro-vitale-tipo">
                        <b-form-select id="parametro-vitale-tipo" v-model="selectedTipoId" :options="tipiOptions" :disabled="loadingTipi || saving" @change="onTipoChange"></b-form-select>
                        <b-form-invalid-feedback>Selezionare un tipo di parametro valido.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Valore" label-for="parametro-vitale-valore">
                        <b-form-input id="parametro-vitale-valore" v-model="jsonData.value" :disabled="saving" :state="valueState" required></b-form-input>
                        <b-form-invalid-feedback>Inserire un valore.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Data e ora rilevazione" label-for="parametro-vitale-data">
                        <date-picker id="parametro-vitale-data" v-model="jsonData.istant" type="datetime" value-type="timestamp" format="DD-MM-YYYY HH:mm" :disabled="saving" :class="{ 'sa-date-invalid': istantState === false }"></date-picker>
                        <div v-if="istantState === false" class="invalid-feedback d-block">Inserire data e ora della rilevazione.</div>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

        <template #modal-footer>
            <b-button variant="outline-danger" :disabled="saving" @click="onCancel">Annulla</b-button>
            <b-button variant="outline-success" :disabled="saving || loadingTipi" @click="onSave">
                <b-spinner v-if="saving" small class="mr-1"></b-spinner>
                Salva
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idPaziente: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            pathResource: "/pazientemisure",
            pathResourceTipi: "/pazientemisuretipi",
            tipiMisurazione: [],
            selectedTipoId: null,
            loadingTipi: false,
            saving: false,
            submitAttempted: false,
            jsonData: this.getEmptyData(),
            idStruttura: null,
        };
    },
    computed: {
        tipiOptions() {
            const options = [{ value: null, text: this.loadingTipi ? "Caricamento..." : "- Seleziona valore -" }];
            this.tipiMisurazione.forEach((tipo, index) => {
                options.push({
                    value: this.getTipoKey(tipo, index),
                    text: this.getTipoLabel(tipo),
                });
            });
            return options;
        },

        valueState() {
            return this.submitAttempted ? this.jsonData.value !== null && String(this.jsonData.value).trim() !== "" : null;
        },
        istantState() {
            return this.submitAttempted ? this.jsonData.istant !== null : null;
        },
        isValid() {
            return this.valueState === true && this.istantState === true && Boolean(this.idPaziente);
        },
    },
    methods: {
        getEmptyData() {
            return {
                istant: Date.now(),
                measurename: null,
                value: "",
                idStruttura: null,
            };
        },
        show() {
            this.selectedTipoId = null;
            this.tipiMisurazione = [];
            this.jsonData = this.getEmptyData();
            this.submitAttempted = false;
            this.saving = false;
            this.$refs.modal.show();
            this.loadTipiMisurazione();
            if (sessionStorage.getItem("idAmbulatorio")) {
                let idAmbulatorio = sessionStorage.getItem("idAmbulatorio");
                this.loadDataAmbulatorio(idAmbulatorio);
            }
        },
        loadTipiMisurazione() {
            this.loadingTipi = true;
            axios
                .get(process.env.VUE_APP_PATH_API + this.pathResourceTipi)
                .then((response) => {
                    const data = response && response.data ? response.data.data : null;
                    this.tipiMisurazione = Array.isArray(data) ? data : [];
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                })
                .finally(() => {
                    this.loadingTipi = false;
                });
        },
        getTipoKey(tipo, index) {
            return tipo.id !== null && tipo.id !== undefined ? String(tipo.id) : "misura-" + tipo.misura + "-" + index;
        },
        getTipoLabel(tipo) {
            const label = tipo.descrizione || tipo.misura || "---";
            return this.getLabelTraduora(label);
        },
        onTipoChange(value) {
            const tipo = this.tipiMisurazione.find((item, index) => this.getTipoKey(item, index) === value);
            this.jsonData.measurename = tipo ? tipo.misura : null;
        },
        onSave() {
            this.submitAttempted = true;
            if (!this.isValid || this.saving) {
                return;
            }

            const payload = {
                idAnagrafica: this.idPaziente,
                istant: this.jsonData.istant,
                measurename: this.jsonData.measurename,
                value: String(this.jsonData.value),
                idStruttura: this.idStruttura,
            };

            this.saving = true;
            axios
                .post(process.env.VUE_APP_PATH_API + this.pathResource, payload)
                .then((response) => {
                    this.$bvToast.toast("Misurazione salvata con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                    this.$refs.modal.hide();
                    this.$emit("onSaveMisurazione", response);
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        onCancel() {
            if (!this.saving) {
                this.$refs.modal.hide();
            }
        },
        onHidden() {
            this.submitAttempted = false;
        },
        loadDataAmbulatorio(id) {
            let path = "/ambulatori";
            UtilityMixin.methods.loadDataResources(path + "/" + id, null, this.resulResponseAmbulatori, null);
        },
        resulResponseAmbulatori(response) {
            console.log(response.data);
            this.idStruttura = response.data.data.idStruttura;
        },
    },
};
</script>

<style scoped>
::v-deep .sa-date-invalid .mx-input {
    border-color: #dc3545;
}
</style>
